export default __webpack_public_path__ + "media/zurb/img/legacy/axe/1-d9d8ddbd23552a8e4c86b1b466683adf.jpg";